import React from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection } from "lexical";
import { $createOperatorNode } from "./OperatorNode";

interface OperatorButton {
  key: string;
  label: string;
  value: string;
  title: string;
}

const OPERATORS: OperatorButton[] = [
  { key: "add", label: "+", value: " + ", title: "Addizione" },
  { key: "subtract", label: "-", value: " - ", title: "Sottrazione" },
  { key: "multiply", label: "×", value: " * ", title: "Moltiplicazione" },
  { key: "divide", label: "÷", value: " / ", title: "Divisione" },
  { key: "openParen", label: "(", value: " ( ", title: "Parentesi aperta" },
  { key: "closeParen", label: ")", value: " ) ", title: "Parentesi chiusa" },
  { key: "greater", label: ">", value: " > ", title: "Maggiore di" },
  { key: "less", label: "<", value: " < ", title: "Minore di" },
  { key: "equal", label: "=", value: " = ", title: "Uguale" },
  { key: "notEqual", label: "≠", value: " ≠ ", title: "Diverso da" }
];

const styles = {
  operatorButton: {
    minWidth: "18px",
    height: "18px",
    padding: "0 4px",
    border: "1.2px solid var(--color-blue, #0078d4)",
    backgroundColor: "white",
    borderRadius: "3px",
    fontSize: "11px",
    fontWeight: "500",
    color: "var(--color-blue, #0078d4)",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  } as React.CSSProperties
};

export const OperatorToolbarPlugin: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  const [editor] = useLexicalComposerContext();

  const insertOperator = (operator: string) => {
    if (disabled) return;

    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        const trimmed = operator.trim();
        const hasLeadingSpace = operator.startsWith(" ");
        const hasTrailingSpace = operator.endsWith(" ");
        if (hasLeadingSpace) selection.insertText(" ");
        selection.insertNodes([$createOperatorNode(trimmed)]);
        if (hasTrailingSpace) selection.insertText(" ");
      }
    });

    setTimeout(() => {
      editor.focus();
    }, 0);
  };

  return (
    <div style={{ display: "flex", gap: "2px", alignItems: "center", flexWrap: "wrap" }}>
      {OPERATORS.map((op) => (
        <button
          key={op.key}
          style={styles.operatorButton}
          onClick={() => insertOperator(op.value)}
          disabled={disabled}
          title={op.title}
          type="button"
          onMouseDown={(e) => e.preventDefault()}
        >
          {op.label}
        </button>
      ))}
    </div>
  );
};

